import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export default function PreventReLogin() {
  const { user } = useSelector((state) => state.user);
  return user === null ? <Outlet /> : <Navigate to={"/"} />;
}